<template>
  <v-card-actions class="justify-center ml-3 rounded transparent battle-actions-row">
    <v-btn
        :loading="isLoading"
        :disabled="!canMove(1)"
        color="warning black--text  btn-shadow"
        @click="backToWild()"
    >
      {{ $t('journey.wildObstacleActions.backLabel') }} <span><v-icon>  mdi-shoe-print </v-icon></span>
    </v-btn>
    <v-btn
        v-if="!passedObstacle"
        :loading="isLoading"
        :disabled="!canMove(2)"
        color="primary black--text  btn-shadow"
        @click="callMeetPokemon(2)"
    >
      {{ $t('journey.wildObstacleActions.goRoundLabel') }} <span class="ml-2"> -2<v-icon>  mdi-shoe-print </v-icon></span>
    </v-btn>
    <v-btn
        v-if="passedObstacle && position.type !== positions.DUNGEON"
        :loading="isLoading"
        color="accent black--text  btn-shadow"
        @click="travel()"
        style="opacity: 1;"
    >
      {{ $t('journey.wildObstacleActions.continueLabel') }}
    </v-btn>
    <v-btn
        v-if="!canMove(2) && !passedObstacle"
        :loading="isLoading"
        dark
        color="accent darken-2 black--white btn-shadow"
        @click="campMeetPokemon()"
    >
      {{ $t('journey.wildObstacleActions.campLabel') }} <span>  <v-icon size="18">mdi-moon-waning-crescent</v-icon><v-icon>mdi-shoe-print</v-icon></span>
    </v-btn>
  </v-card-actions>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {Positions} from '@/utils/positionEnum';
import {API_ENTRYPOINT} from "@/config/entrypoint";

// Akce pro samostatnou divokou překážku (mimo dungeon) - dřív jen natvrdo
// vykreslené v ObstacleFight.vue, nikdy neextrahované do vlastní komponenty.
// Jiná sada akcí než dungeon-překážka nebo divoký souboj (viz matice v
// claude/battle-screen-design.md) - "Back"/"Go round -2"/"Camp"/"Continue".
export default {
  name: "WildObstacleActions",
  props: {
    position: {type: Object, required: true},
    obstacleFight: {type: Object, default: null},
  },
  data() {
    return {
      positions: Positions,
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'journey/isLoading',
      user: 'user/item',
      steps: 'journey/steps',
    }),
    passedObstacle() {
      return this.obstacleFight !== null && this.obstacleFight.currentHp < 1;
    },
  },
  methods: {
    ...mapActions({
      positionPost: 'journey/positionPost',
      meetPokemon: 'journey/meetPokemon',
      campPokemon: 'journey/campMeetPokemon',
    }),
    canMove(steps) {
      return steps <= this.steps;
    },
    callMeetPokemon(step = 1) {
      const obj = {positionId: this.user.position.id, environment: this.position.wild.type, stepCost: step, actualWildType: this.position.actualWildType};
      this.meetPokemon(obj);
    },
    campMeetPokemon() {
      const obj = {positionId: this.user.position.id, environment: this.position.wild.type, actualWildType: this.position.actualWildType};
      this.campPokemon(obj);
    },
    backToWild() {
      const url = new URL("api/back-to-wild", API_ENTRYPOINT);
      const obj = {url: url, obj: {positionId: this.user.position.id, stepCost: 1}, method: 'POST'}
      this.positionPost(obj);
    },
    travel() {
      const url = new URL("api/travel", API_ENTRYPOINT);
      const obj = {url: url, obj: {positionId: this.user.position.id}, method: 'POST'}
      this.positionPost(obj);
    },
  },
}
</script>

<style scoped>
/* Zadani uzivatele 2026-07-24 - puvodne "kdyz se nevejdou do jednoho
   radku, zalom do dvou", ale po zivem otestovani uzivatel usoudil, ze
   nahodne naskakujici druhy radek vypada spatne ("to ze nekdy naskoci dva
   radky najednou je nahovno") - misto zalomeni radsi natvrdo drzet
   tlacitka na jednom radku a zmensit padding, at se vejdou i s vice
   tlacitky na mobilni sirku. Stejna zmena jako v DungeonButtons.vue -
   viz komentar tam. */
.battle-actions-row {
    flex-wrap: nowrap;
}
.battle-actions-row >>> .v-btn {
    padding: 0 8px;
    min-width: 0;
}
</style>
